import { t } from 'i18next'

import { Selected } from '@/shared/icons/Selected'

interface ProgressBarProps {
  progressBar?: {
    paymentStepValue: string
    downloadStepValue: string
    loginStepValue: string
  }
}

export const SuccessPageProgressBar = ({ progressBar }: ProgressBarProps) => {
  const paymentStepValue = `${t('paymentSuccessPage.progressBar.paymentStepValue') || progressBar?.paymentStepValue || 'Payment'}`
  const downloadStepValue = `${t('paymentSuccessPage.progressBar.downloadStepValue') || progressBar?.downloadStepValue || 'Download <br> the app'}`
  const loginStepValue = `${t('paymentSuccessPage.progressBar.loginStepValue') || progressBar?.loginStepValue || 'Login'}`

  return (
    <div className="steps-to-success">
      <div className="step-description"></div>
      <div className="container">
        <div className="step completed">
          <div
            className="label payment-step"
            dangerouslySetInnerHTML={{ __html: paymentStepValue }}
          />
          <Selected />
        </div>
        <div className="line red" />
        <div className="step current">
          <div
            className="label download-step"
            dangerouslySetInnerHTML={{ __html: downloadStepValue }}
          />
          <div className="dot" />
        </div>
        <div className="line" />
        <div className="step last">
          <div className="label login-step" dangerouslySetInnerHTML={{ __html: loginStepValue }} />
        </div>
      </div>
    </div>
  )
}
